export default defineNuxtPlugin({
//   setup() {
//     const api = $fetch.create({
//       baseURL: process.env.API_ENDPOINT,
//       headers: {
//         "X-CLIENT-ID": "8447",
//         Accept: "application/json",
//         "Accept-Language": "en",
//         "Sec-Fetch-Dest": "empty",
//         "Sec-Fetch-Mode": "cors",
//         "Sec-Fetch-Site": "same-site",
//         "User-Agent":
//           "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/119.0.0.0 Safari/537.36",
//       },
//     });
//     return {
//       provide: {
//         api,
//       },
//     };
//   },
});
